import React, { useEffect, useState } from 'react'
import { View, Text, Platform } from 'react-native'
import { RoundedTabs } from '../customUtils/LinealTabs'
import { Loader } from '../customUtils/Components/Loader'
import theme from '../../../theme'
import styles from './TriviaScreenStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { TriviaList } from './TriviaList'
import { TriviaRankingList } from './TriviaRankingList'
import { TriviaCard } from './TriviaCard'
import { request_get_games, request_ranking } from '../../services/trivia.services'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import { useNavigation } from '../../hooks/useWebNavigation'
import { getData, THEME_COLOR_ALERT } from '../appBar/context/HeaderContext'
import { resetCache } from '../../utils/FetchServices'
import { triviaMainColor, TriviaTheme } from '../../../themeConstants'
import { getAlert } from '../appBar/context/AlertsContext'
import NetInfo from '@react-native-community/netinfo'

const isWeb = Platform.OS === 'web'
export const TriviaScreen = () => {
    const [loading, setLoading] = useState(true)
    const [indexTab, setIndexTab] = useState(0)

    const { languageFile } = getLanguage()

    const tabs = [
        { name: 'Trivia', index: 0 },
        { name: 'Ranking', index: 1 },
    ]
    const [userRank, setUserRank] = useState({ score: 0, position: 0 })
    const { score, position } = userRank
    const [ranking, setRanking] = useState([])
    const [trivias, setTrivias] = useState([])
    const navigation = useNavigation()
    const { setCurrentFooterRoute } = getData()
    const { setAlert } = getAlert()
    // Initial load on mount (important for web)
    useEffect(() => {
        console.log('[TriviaScreen] Component mounted, loading data...')
        setCurrentFooterRoute('Trivia')
        fetchData()
    }, [])

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            console.log('[TriviaScreen] Navigation focus event')
            setLoading(true)
            {
                setCurrentFooterRoute('Trivia')
                fetchData()
            }
        })
        return unsubscribe
    }, [navigation])

    const fetchData = async () => {
        try {
            console.log('[TriviaScreen][fetchData] START')
            const authToken = await getAuthToken()
            if (!authToken) {
                console.warn(
                    '[TriviaScreen][fetchData] no authToken; skipping remote calls and keeping local state',
                )
                setTrivias([])
                setRanking([])
                resetCache()
                return
            }
            console.log(
                '[TriviaScreen][fetchData] Auth token length:',
                authToken.length,
            )
            const netInfoState = await NetInfo.fetch()
            if (!netInfoState.isConnected) {
                setAlert(
                    'No tienes conexión',
                    'white',
                    'wifi-off',
                    THEME_COLOR_ALERT.ERROR,
                )
            }
            const data = await request_get_games({ authToken })
            const ranking = await request_ranking({ authToken })

            console.log(
                '[TriviaScreen][fetchData] Games received:',
                data.single?.games?.length || 0,
            )
            console.log(
                '[TriviaScreen][fetchData] Ranking positions:',
                ranking.single?.positions?.length || 0,
            )

            if (ranking.single.user_position) {
                console.log(
                    '[TriviaScreen][fetchData] User rank:',
                    ranking.single.user_position,
                )
                setUserRank(ranking.single.user_position)
            }
            if (ranking.single.positions && ranking.single.positions.length > 0) {
                setRanking(ranking.single.positions)
            }
            if (data.single.games && data.single.games.length > 0) {
                let validGames = validateArrayDates(data.single.games)
                console.log(
                    '[TriviaScreen][fetchData] Valid games after date filter:',
                    validGames.length,
                )
                setTrivias(validGames)
            }
            resetCache()
        } catch (error) {
            console.error('[TriviaScreen][fetchData] ERROR:', error)
        } finally {
            setLoading(false)
            console.log('[TriviaScreen][fetchData] COMPLETE')
        }
    }
    const validateArrayDates = (array: any) => {
        const TODAY = new Date()
        console.log(
            '[TriviaScreen][validateArrayDates] Filtering',
            array.length,
            'games',
        )
        let validItems = array.filter((item: any) => {
            let date_init = new Date(item.date_init)
            let date_finish = new Date(item.date_finish)
            const isValid = date_init <= TODAY && TODAY <= date_finish
            if (isValid) {
                console.log(
                    '[TriviaScreen][validateArrayDates] Valid trivia:',
                    item.name,
                )
            }
            return isValid
        })
        console.log(
            '[TriviaScreen][validateArrayDates] Result:',
            validItems.length,
            'valid games',
        )
        return validItems
    }
    // console.log('[TriviaScreen] RENDER - loading:', loading, 'trivias:', trivias.length, 'indexTab:', indexTab)

    if (loading) {
        return <Loader />
    }

    return (
        // Padre para centrar contenido en web
        <View style={styles.container}>
            {/* Contenido original */}
            <View
                style={[
                    styles.container,
                    isWeb && {
                        maxWidth: 1024,
                        alignSelf: 'center',
                        flex: undefined,
                    },
                ]}
            >
                <RoundedTabs
                    tabs={tabs}
                    selectedIndex={indexTab}
                    colorLGStart={TriviaTheme.triviaGradient[0]}
                    colorLGEnd={TriviaTheme.triviaGradient[1]}
                    colorSelected={TriviaTheme.tabsSelectedColor}
                    colorUnselected={TriviaTheme.tabsUnselectedColor}
                    onSelectedTab={(i) => {
                        console.log('[TriviaScreen] Tab selected:', i)
                        setIndexTab(i)
                    }}
                    textColorOn={triviaMainColor}
                    textColorOff={theme.colors.textPrimary}
                />
                {indexTab != 1 && (
                    <TriviaCard
                        position={position ? position : 0}
                        points={score ? score : 0}
                    />
                )}

                <View style={{ flex: 1 }}>
                    {(() => {
                        switch (indexTab) {
                            case 0:
                                return (
                                    <TriviaList
                                        points={score ? score : 0}
                                        trivias={trivias}
                                    />
                                )
                            case 1:
                                return (
                                    <TriviaRankingList
                                        ranking={ranking}
                                        hasTrivias={trivias.length > 0}
                                    />
                                )
                            default:
                                return (
                                    <Text>{languageFile.there_was_a_mistake}</Text>
                                )
                        }
                    })()}
                </View>
            </View>
        </View>
    )
}
